import ApiClient from 'api-client/ApiClient'
import ActionsSet from 'core/actions/ActionsSet'
import CustomAction from 'core/actions/CustomAction'
import ListAction from 'core/actions/ListAction'
import DataKeys, { entityNamesByKey } from 'k8s/DataKeys'

const { nova, cinder, neutron, glance, keystone } = ApiClient.getInstance()

export const computeServiceActions = ActionsSet.make<DataKeys.ComputeServiceDetails>({
  uniqueIdentifier: 'id',
  entityName: entityNamesByKey.ComputeServiceDetails,
  cacheKey: DataKeys.ComputeServiceDetails,
})

export const listComputeServiceDetails = computeServiceActions.add(
  new ListAction<DataKeys.ComputeServiceDetails>(async () => {
    const computeServiceDetails = await nova.getComputeServiceDetails()
    return computeServiceDetails
  }),
)

export const storageServiceActions = ActionsSet.make<DataKeys.StorageServiceDetails>({
  uniqueIdentifier: 'host',
  entityName: entityNamesByKey.StorageServiceDetails,
  cacheKey: DataKeys.StorageServiceDetails,
  addCacheKey: DataKeys.StorageServiceDetails,
})

export const listStorageServiceDetails = storageServiceActions.add(
  new ListAction<DataKeys.StorageServiceDetails>(async () => {
    const storageServiceDetails = await cinder.getStoarageServiceDetails()
    return storageServiceDetails
  }),
)

export const networkServiceActions = ActionsSet.make<DataKeys.NetworkServiceDetails>({
  uniqueIdentifier: 'id',
  entityName: entityNamesByKey.NetworkServiceDetails,
  cacheKey: DataKeys.NetworkServiceDetails,
})

export const listNetworkServiceDetails = networkServiceActions.add(
  new ListAction<DataKeys.NetworkServiceDetails>(async () => {
    return neutron.getNetworkStoarageDetails()
  }),
)

export const imageServiceActions = ActionsSet.make<DataKeys.ImageServiceDetails>({
  uniqueIdentifier: 'id',
  entityName: entityNamesByKey.ImageServiceDetails,
  cacheKey: DataKeys.ImageServiceDetails,
})

export const listImageServiceDetails = imageServiceActions.add(
  new ListAction<DataKeys.ImageServiceDetails>(async () => {
    //Get glance cluster service
    const glanceEndpointsService = (await keystone.getServiceCatalog())?.find(
      (service) => service?.name === 'glance-cluster',
    )
    //Get glance cluster sendpoints
    const glanceEndpoints =
      glanceEndpointsService?.endpoints?.flatMap((endpoint) => ({
        url: endpoint?.url,
        id: endpoint?.id,
      })) || []

    const responses = await Promise.all(
      glanceEndpoints?.map(async (endpoint) => {
        const response = await glance.getImageServiceHealth(endpoint.url)
        return {
          ...response,
          host: endpoint.url,
          endpoint: endpoint.url,
          zone: glanceEndpointsService?.type,
          id: endpoint.id,
        }
      }),
    )
    const imageServiceDetails = [...responses]

    return imageServiceDetails
  }),
)
